export default __webpack_public_path__ + "static/media/gallery-4-3.066070de.jpg";